import { useCallback, useMemo } from 'react';

export const useSelectAll = (
  visibleIds: number[],
  selectedIds: number[],
  onCheck: (ids: number[]) => void,
) => {
  const selectedSet = useMemo(() => new Set(selectedIds), [selectedIds]);
  const allSelected = visibleIds.length > 0 && visibleIds.every((id) => selectedSet.has(id));
  const someSelected = !allSelected && visibleIds.some((id) => selectedSet.has(id));

  const toggleAll = useCallback(() => {
    if (allSelected) onCheck(selectedIds.filter((id) => !visibleIds.includes(id)));
    else onCheck(Array.from(new Set([...selectedIds, ...visibleIds])));
  }, [allSelected, onCheck, selectedIds, visibleIds]);

  return { allSelected, selectedSet, someSelected, toggleAll };
};
